"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (lowerBound, upperBound) {
  return function (value) {
    return value <= upperBound && value >= lowerBound;
  };
};


//////////////////
// WEBPACK FOOTER
// /home/caligram/admin.caligram.com/shared/~/react-beautiful-dnd/lib/state/is-within.js
// module id = 294
// module chunks = 0